import { render, staticRenderFns } from "./firma_digital_simple.vue?vue&type=template&id=5a496839"
import script from "./firma_digital_simple.vue?vue&type=script&lang=js"
export * from "./firma_digital_simple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports